interface ACAReportingHeaderProps {
  planYear: number
}

export default function ACAReportingHeader ({ planYear }: ACAReportingHeaderProps) {
  return (
    <>
      <div className='flex justify-between gap-2 items-center mb-2'>
        <div className='flex items-center'>
          <h1 className='heading-lg'>{planYear} ACA reporting</h1>
        </div>
      </div>

      <p className='text-gray-500 mb-6'>
        As an employer with an ICHRA, you're required to report information about your health benefit offerings to both your employees and the IRS. ACA reporting is available to employers who have used Thatch for the entire plan year and who do not offer health benefits off-Thatch.
      </p>
    </>
  )
}
